/**
 * Program: i18n
 * Author: SDL
 * Description: i18n language setting file
 */
// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
import Vue          from 'vue';
import VueI18n      from 'vue-i18n';
import axios        from 'axios';
import store        from '@/vuex/store';
import SDLUtil      from '@/utils/SDLUtil';

Vue.use(VueI18n);

const defaultLanguage = (window.navigator.userLanguage || window.navigator.language || 'en-US').replace('-', '_').split('_')[0];
export const i18n = new VueI18n({
    locale: defaultLanguage, // set locale
    fallbackLocale: defaultLanguage,
    messages: {}, // set locale messages
});

let loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
    i18n.locale = lang;
    store.commit('LOCALE', lang);
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    return lang;
}

export function loadLanguageAsync(lang) {
    Vue.$log.info("☞ i18n - current loadedLanguages => ", loadedLanguages);
    if (!loadedLanguages.includes(lang)) {
        Vue.$log.info("☞ i18n - not include ['" + lang + "']. start i18n.loadLanguageAsync");
        return axios.get(`${SDLUtil.API_URL}/noauth/i18n/listMessageByLanguage.skp?lang=${lang}`).then(msgs => {
            loadedLanguages = Object.keys(msgs.data);
            loadedLanguages.forEach(country => {
                i18n.setLocaleMessage(country, msgs.data[country]);
            });
            
            return setI18nLanguage(lang);
        });
    }
    return Promise.resolve(setI18nLanguage(lang));
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js